<mat-card class="cardWithShadow theme-card" style="margin-bottom: 10px;margin-top: -20px;" *ngIf="!isTempClient">
  <mat-card-header>
    <button mat-flat-button color="primary" (click)="volver()">
      <i-tabler class="custom-icon" name="arrow-left"></i-tabler>
      <span class="button-text">Volver</span>
    </button>
  </mat-card-header>
</mat-card>


<mat-card class="cardWithShadow theme-card">
  <mat-card-content class="b-t-1">
    <div class="row" [ngClass]="{'justify-content-center': isTempClient}">
      <div [ngClass]="isTempClient ? 'col-md-10 col-lg-8' : 'col-md-6'">
        <div class="row">


          <div class="row">
            <h4> Datos de la Tarjeta</h4>
          </div>

          <div class="row" *ngIf="!isTempClient">
            <span style="margin-bottom: 25px;"> {{ tarjeta.linkProfile ?? '' }}</span>
          </div>

          <form #form="ngForm" (ngSubmit)="guardarTarjeta()" class="w-100">

            <!-- Container Paso 1 para Clientes Temporales -->
            <div [ngClass]="{'step-container': isTempClient}">
              <h5 *ngIf="isTempClient" class="mb-3 text-primary fw-bold">Activa tu credencial y comienza a ahorrar hoy.
              </h5>
              <h4 *ngIf="isTempClient" class="step-title" style="margin-bottom: 20px;">Ingresa tus datos</h4>

              <mat-form-field appearance="outline" class="w-100" *ngIf="!isTempClient">
                <mat-label>Perfil de la Tarjeta</mat-label>
                <mat-select [(ngModel)]="selectedPerfil" name="selectedPerfil" required
                  (selectionChange)="onPerfilChange()">
                  <mat-option *ngFor="let perfil of perfiles" [value]="perfil.id">
                    {{ perfil.nombre }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.submitted && !selectedPerfil">Perfil requerido</mat-error>
              </mat-form-field>

              <div class="row mb-3" *ngIf="!isTempClient">
                <h5 class="mb-2">Redes Sociales de la Tarjeta</h5>
                <mat-slide-toggle class="btn-primary" labelPosition="before" [(ngModel)]="tarjeta.showRSComponent"
                  name="showCardRSComponent" (change)="toggleChangedRSComponent($event.checked)">
                  <label class="custom-upload-label">Mostrar Redes Sociales de la Tarjeta</label>
                </mat-slide-toggle>

                <div *ngIf="tarjeta?.showRSComponent" class="mt-2 upload-container">
                  <label class="custom-upload-label">Configurar Redes Sociales de la Tarjeta</label>

                  <div *ngFor="let red of tarjeta?.redes; let i = index" class="mb-2 card p-3">
                    <select [(ngModel)]="red.tipo" [name]="'cardRedTipo' + i" (ngModelChange)="normalizeCardSocials()"
                      class="form-select my-1">
                      <option value="facebook">Facebook</option>
                      <option value="instagram">Instagram</option>
                      <option value="twitter">Twitter</option>
                      <option value="linkedin">LinkedIn</option>
                      <option value="youtube">YouTube</option>
                      <option value="tiktok">TikTok</option>
                      <option value="promo">Promociones</option>
                    </select>

                    <input type="text" placeholder="Link" [(ngModel)]="red.link" [name]="'cardRedLink' + i"
                      (ngModelChange)="normalizeCardSocials()" class="form-control my-1" />

                    <button class="btn btn-danger btn-sm" type="button" (click)="removeRedSocial(i)">Eliminar</button>
                  </div>

                  <button class="btn btn-success btn-sm my-2" type="button" (click)="addRedSocial()">Agregar Red Social</button>
                </div>
              </div>

              <!-- IMAGEN PERFIL -->
              <div class="row mt-3">
                <div class="upload-container">
                  <label for="imgUpload" class="custom-upload-label">Sube tu foto de Perfil:</label>
                  <input id="imgUpload" type="file" (change)="onFileChange($event, 'img')" accept="image/*"
                    class="custom-upload-input" name="imgProfile" />
                </div>
              </div>

              <!-- Nombre (obligatorio) -->
              <mat-form-field appearance="outline" class="w-100 phone-field">
                <mat-label>Nombre y Apellido</mat-label>
                <input matInput [(ngModel)]="tarjeta.nombre" name="nombre" required />
                <mat-error *ngIf="form.submitted && !tarjeta.nombre">Nombre requerido</mat-error>
              </mat-form-field>

              <!-- Selector Club Deportivo -->
              <div class="row mb-3" *ngIf="!isTempClient">
                <div class="col-12">
                  <mat-slide-toggle [(ngModel)]="isSportsClub" name="isSportsClub" color="primary"
                    (change)="updateSportsCargo()">
                    Credencial de Club Deportivo
                  </mat-slide-toggle>
                </div>
              </div>

              <div *ngIf="isSportsClub && !isTempClient" class="sports-club-section p-3 mb-3"
                style="border: 1px solid #e0e0e0; border-radius: 8px; background-color: #fbfbfb;">
                <h6 class="mb-3 text-secondary fw-bold">Perfil – Credenciales Deportivas – Club</h6>

                <mat-form-field appearance="outline" class="w-100 mb-2">
                  <mat-label>Cargo</mat-label>
                  <input matInput [(ngModel)]="sportsData.cargo" name="sportsCargo"
                    (ngModelChange)="updateSportsCargo()" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 mb-2">
                  <mat-label>RUT</mat-label>
                  <input matInput [(ngModel)]="sportsData.rut" name="sportsRut" (ngModelChange)="updateSportsCargo()" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100 mb-2">
                  <mat-label>Fecha de nacimiento (opcional)</mat-label>
                  <input matInput [(ngModel)]="sportsData.fechaNacimiento" name="sportsFechaNacimiento"
                    (ngModelChange)="updateSportsCargo()" />
                </mat-form-field>

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Institución (Club)</mat-label>
                  <input matInput [(ngModel)]="sportsData.institucion" name="sportsInstitucion"
                    (ngModelChange)="updateSportsCargo()" />
                </mat-form-field>
              </div>

              <!-- Selector Chatboot: solo admin global -->
              <div class="row mb-3" *ngIf="isGlobalAdmin">
                <div class="col-12">
                  <mat-slide-toggle [(ngModel)]="tarjeta.showChatboot" name="showChatboot" color="primary">
                    Chatboot
                  </mat-slide-toggle>
                </div>
              </div>

              <mat-form-field appearance="outline" class="w-100" *ngIf="isGlobalAdmin && tarjeta.showChatboot">
                <mat-label>URL Chatboot</mat-label>
                <input matInput [(ngModel)]="tarjeta.urlChatboot" name="urlChatboot" type="url"
                  placeholder="https://..." />
              </mat-form-field>

              <!-- Cargo (obligatorio) -->
              <div class="w-100" style="margin-bottom: 16px;"
                *ngIf="!isTempClient && !isSportsClub && !tarjeta?.cargo?.includes('[SPORTS_CLUB]')">
                <label class="mat-label" style="display:block;margin-bottom:4px;">Cargo</label>
                <ckeditor *ngIf="isBrowser && Editor" [editor]="Editor" [(ngModel)]="tarjeta.cargo"
                  (ngModelChange)="onCargoChange($event)" name="cargo" required></ckeditor>
                <mat-error *ngIf="form.submitted && !tarjeta.cargo?.trim()">Cargo requerido</mat-error>
              </div>

              <!-- Ubicación -->
              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Región</mat-label>
                <mat-select [(ngModel)]="selectedRegionId" (selectionChange)="onRegionChange($event.value)" name="idRegion">
                  <mat-option *ngFor="let region of regiones" [value]="region.id ?? region.idRegion">
                    {{ region.region || region.nombre || region.name || ('Región #' + (region.id ?? region.idRegion ?? '')) }}
                  </mat-option>
                </mat-select>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Comuna</mat-label>
                <mat-select [(ngModel)]="tarjeta.idComuna" name="idComuna" [disabled]="!selectedRegionId" required>
                  <mat-option *ngFor="let comuna of comunas" [value]="comuna.id ?? comuna.idComuna">
                    {{ comuna.comuna || comuna.nombre || comuna.name || ('Comuna #' + (comuna.id ?? comuna.idComuna ?? '')) }}
                  </mat-option>
                </mat-select>
                <mat-error *ngIf="form.submitted && !tarjeta.idComuna">La comuna es obligatoria.</mat-error>
              </mat-form-field>

              <mat-form-field appearance="outline" class="w-100">
                <mat-label>Dirección (detalle opcional)</mat-label>
                <input matInput [(ngModel)]="tarjeta.direccion" name="direccion" />
              </mat-form-field>


              <!-- Teléfono -->
              <mat-form-field appearance="outline" class="w-100 phone-field">
                <mat-label>Teléfono</mat-label>
                <span matPrefix class="phone-prefix" *ngIf="!isAdmin">+56 9&nbsp;</span>
                <input matInput [(ngModel)]="tarjeta.telefono" name="telefono" required
                  [placeholder]="isAdmin ? '+56 9 1234 5678' : '12345678'" [maxlength]="isAdmin ? '' : '8'" />
                <mat-error *ngIf="form.submitted && !tarjeta.telefono">Teléfono requerido</mat-error>
              </mat-form-field>

              <!-- WhatsAap -->
              <mat-form-field appearance="outline" class="w-100 phone-field" *ngIf="!isTempClient">
                <mat-label>WhatsAap</mat-label>
                <span matPrefix class="phone-prefix" *ngIf="!isAdmin">+56 9&nbsp;</span>
                <input matInput [(ngModel)]="tarjeta.wsp" name="wsp" required
                  [placeholder]="isAdmin ? '+56 9 1234 5678' : '12345678'" [maxlength]="isAdmin ? '' : '8'" />
                <mat-error *ngIf="form.submitted && !tarjeta.wsp">Whatsaap requerido</mat-error>
              </mat-form-field>

              <!-- Correo -->
              <mat-form-field appearance="outline" class="w-100" *ngIf="!isTempClient">
                <mat-label>Correo</mat-label>
                <input matInput [(ngModel)]="tarjeta.correo" name="correo" type="email" required />
                <mat-error *ngIf="form.submitted && !tarjeta.correo">Correo requerido</mat-error>
              </mat-form-field>

              <!-- Fecha de expiración (15 días después por defecto) -->
              <mat-form-field appearance="outline" class="w-100" *ngIf="isGlobalAdmin">
                <mat-label>Fecha de expiración</mat-label>
                <input matInput [matDatepicker]="picker" [(ngModel)]="tarjeta.endDate" name="endDate"
                  [disabled]="hasMasterCard" />
                <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="hasMasterCard"></mat-datepicker-toggle>
                <mat-datepicker #picker [disabled]="hasMasterCard"></mat-datepicker>
              </mat-form-field>

              <!-- Mensaje Expiración de Master Card -->
              <div *ngIf="isGlobalAdmin && hasMasterCard"
                class="d-flex align-items-center gap-2 p-2 mt-1 mb-3 rounded-2 bg-light-info text-info"
                style="font-size: 13px; border: 1px solid #c9e0fa;">
                <i-tabler name="info-circle" class="icon-18 text-info"></i-tabler>
                <span class="fw-medium">Esta fecha se toma automáticamente de la <strong>Tarjeta Maestra</strong> del
                  cliente.</span>
              </div>

              <!-- Boton Guardar en Paso 1 para Clientes Temporales -->
              <div class="d-flex justify-content-end mt-3" *ngIf="isTempClient">
                <button mat-flat-button color="primary" type="submit">Guardar y Ver Tarjeta</button>
              </div>
            </div>

            <!-- Mobile Preview REMOVED per user request for natural stacking -->

            <!-- Original Buttons for Non-Temp Clients -->
            <div class="d-flex gap-2" *ngIf="!isTempClient">
              <button mat-flat-button color="primary" type="submit">Guardar</button>
              <button mat-flat-button color="primary" type="button" *ngIf="tarjeta?.uid" (click)="verTarjeta()">
                Ver Tarjeta
              </button>
            </div>

          </form>
        </div>
      </div>

      <!-- Right Column: Normal Preview for Non-Temp Clients -->
      <div class="col-md-6 card-preview-container-col" *ngIf="!isTempClient">

        <!-- Normal Preview (Non-Temp) -->
        <div class="d-flex justify-content-center w-100">
          <app-tarjeta [profile]="profile" [tarjeta]="tarjeta"></app-tarjeta>
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>

<ng-template #cardDialogTemplate>
  <div class="dialog-content text-center py-4 px-2" style="max-height: 85vh; overflow-y: auto; overflow-x: hidden;">

    <!-- Add to Home Screen Instructions -->
    <h6 class="mb-3 mt-2 fw-bold text-center" style="font-size: 1.1rem;"><i
        class="fas fa-id-card text-primary me-1"></i> ¿COMO LA DESCARGO?</h6>

    <div class="d-flex justify-content-center gap-2 mb-3">
      <button (click)="showInstruction('android')" class="btn btn-outline-dark p-2"
        [ngClass]="{'active text-white bg-dark': instruction === 'android'}"
        style="width: 100px; height: 85px; border-radius: 12px;">
        <i class="fab fa-android mb-1" style="font-size: 2rem;"></i><br><span
          style="font-size: 0.8rem; font-weight: 500;">Android</span>
      </button>
      <button (click)="showInstruction('ios')" class="btn btn-outline-dark p-2"
        [ngClass]="{'active text-white bg-dark': instruction === 'ios'}"
        style="width: 100px; height: 85px; border-radius: 12px;">
        <i class="fab fa-apple mb-1" style="font-size: 2rem;"></i><br><span
          style="font-size: 0.8rem; font-weight: 500;">iOS</span>
      </button>
    </div>

    <div *ngIf="instruction === 'android'" class="text-start bg-light p-3 rounded-3 border mb-3 mx-auto shadow-sm"
      style="max-width:380px;">
      <h6 class="fw-bold mb-2 text-dark"><i class="fab fa-android text-success"></i> Android</h6>
      <p class="small mb-2 text-muted" style="font-size: 0.9rem;">Para descargar esta tarjeta en tu móvil Android desde
        el
        navegador web Google Chrome.</p>
      <div class="d-flex align-items-start gap-2 mt-2">
        <i class="fas fa-ellipsis-v mt-1 text-secondary" style="font-size: 1.1rem; width: 15px;"></i>
        <p class="small mb-0 text-dark" style="font-size: 0.85rem;">Pulsa éste botón en la parte superior de la pantalla
          y
          selecciona la opción <strong>'Agregar a la pantalla de inicio'</strong>. Para confirmar, deberás
          presionar la opción <strong>'Agregar'</strong>.</p>
      </div>
    </div>

    <div *ngIf="instruction === 'ios'" class="text-start bg-light p-3 rounded-3 border mb-3 mx-auto shadow-sm"
      style="max-width:380px;">
      <h6 class="fw-bold mb-2 text-dark"><i class="fab fa-apple text-dark"></i> iOS</h6>
      <p class="small mb-2 text-muted" style="font-size: 0.9rem;">Para añadir esta tarjeta en tu iPhone desde el
        navegador
        web Safari.
      </p>
      <div class="d-flex align-items-start gap-2 mt-2">
        <i class="fas fa-share-from-square mt-1 text-primary" style="font-size: 1.1rem; width: 15px;"></i>
        <p class="small mb-0 text-dark" style="font-size: 0.85rem;">Pulsa éste botón en la parte inferior central de la
          pantalla y selecciona la opción <strong>'Añadir a pantalla de inicio'</strong>. Para confirmar, deberás
          presionar la opción <strong>'Añadir'</strong>.</p>
      </div>
    </div>

    <div class="d-flex justify-content-center mt-4 mb-2">
      <button mat-flat-button color="primary" type="button" (click)="cerrarDialogo()"
        style="min-width: 150px; font-weight: 600; padding: 6px 16px;">
        Continuar
      </button>
    </div>
  </div>
</ng-template>
